export default __webpack_public_path__ + "static/media/agency1.024ace6b.png";